module.exports = __webpack_public_path__ + "static/media/landing-logo.b38f3b1a.svg";